import { createReducer } from "@reduxjs/toolkit";
const initialState = {
  loading: false,
  status: null,
  success: null, 
  message: null,
  data: [],

  states: {
    loading: false,
    status: null,
    message: null,
    data: null,
  },
  regions: {
    loading: false,
    status: null,
    message: null,
    data: null,
  },
  expenditureAnalysis: {
    loading: false,
    status: null,
    message: null,
    data: null,
    percentageExpenditureByCategory: null,
    averageMpce: null,
  },
  marketSizeAnalysis: {
    loading: false,
    success: null,
    message: null,
    data: [],
  },
};

const categorySizeReducer = createReducer(initialState, {

GET_MARKET_SIZE_REQUEST: (state) => {
  state.marketSizeAnalysis.loading = true;
  state.marketSizeAnalysis.success = null;
  state.marketSizeAnalysis.message = null;
  state.marketSizeAnalysis.data = [];
},
GET_MARKET_SIZE_SUCCESS: (state, action) => {
  const { success, message, data } = action.payload;
  state.marketSizeAnalysis.loading = false;
  state.marketSizeAnalysis.success = success;
  state.marketSizeAnalysis.message = message;
  state.marketSizeAnalysis.data = data;
},
GET_MARKET_SIZE_FAILURE: (state, action) => {
  state.marketSizeAnalysis.loading = false;
  state.marketSizeAnalysis.success = false;
  state.marketSizeAnalysis.message = action.payload;
  state.marketSizeAnalysis.data = [];
},

  GET_STATES_REQUEST: (state) => {
    state.states.loading = true;
    state.states.status = null;
    state.states.message = null;
    state.states.data = null;
  },
  GET_STATES_SUCCESS: (state, action) => {
    console.log('Reducer received states:', action.payload.data);
    const { status, message, data } = action.payload;
    state.states.loading = false;
    state.states.status = status;
    state.states.message = message;
    state.states.data = data;
  },
  GET_STATES_FAILURE: (state, action) => {
    state.states.loading = false;
    state.states.status = 'error';
    state.states.message = action.payload;
    state.states.data = null;
  },

  GET_REGIONS_REQUEST: (state) => {
    state.regions.loading = true;
    state.regions.status = null;
    state.regions.message = null;
    state.regions.data = null;
  },
  GET_REGIONS_SUCCESS: (state, action) => {
    const { status, message, data } = action.payload;
    state.regions.loading = false;
    state.regions.status = status;
    state.regions.message = message;
    state.regions.data = data;
  },
  GET_REGIONS_FAILURE: (state, action) => {
    state.regions.loading = false;
    state.regions.status = 'error';
    state.regions.message = action.payload;
    state.regions.data = null;
  },

  GET_EXPENDITURE_ANALYSIS_REQUEST: (state) => {
    state.expenditureAnalysis.loading = true;
    state.expenditureAnalysis.success = null;
    state.expenditureAnalysis.message = null;
    state.expenditureAnalysis.data = null;
    state.expenditureAnalysis.percentageExpenditureByCategory = null;
    state.expenditureAnalysis.averageMpce = null;
  },
  GET_EXPENDITURE_ANALYSIS_SUCCESS: (state, action) => {
    console.log('Reducer received expenditure analysis:', action.payload.data);
    const { success, message, data } = action.payload;
    state.expenditureAnalysis.loading = false;
    state.expenditureAnalysis.success = success;
    state.expenditureAnalysis.message = message;
    state.expenditureAnalysis.data = data;

    if (data) {
      state.expenditureAnalysis.percentageExpenditureByCategory = data.percentageExpenditureByCategory;
      state.expenditureAnalysis.averageMpce = data.averageMpce;
    }
  },
  GET_EXPENDITURE_ANALYSIS_FAILURE: (state, action) => {
    state.expenditureAnalysis.loading = false;
    state.expenditureAnalysis.success = false;
    state.expenditureAnalysis.message = action.payload;
    state.expenditureAnalysis.data = null;
    state.expenditureAnalysis.percentageExpenditureByCategory = null;
    state.expenditureAnalysis.averageMpce = null;
  },
});

export default categorySizeReducer;
